import { callFirebaseFunction } from "@/bridge/callFirebaseFunction";
import { usePromise } from "@/hooks/usePromise";
import type { DependencyList } from "react";

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function useFirebaseFunction<RequestData = any, ResponseData = any>(
  name: string,
  caller: (
    httpsCallable: (args: RequestData) => Promise<ResponseData>
  ) => Promise<ResponseData>,
  deps: DependencyList = []
): [
  ResponseData | undefined,
  boolean,
  Error | undefined,
  () => Promise<ResponseData>
] {
  const fn = callFirebaseFunction<RequestData, ResponseData>;

  return usePromise(() => caller(fn.bind(null, name)), deps);
}
